module.exports = __webpack_public_path__ + "img/close-dialog.149e4ee2.svg";